import "./About.css";

const About = () => {
  return (
    <div className="about-container">
      {/* Primul rând */}
      <div className="about-row bordered">
        <div className="about-text">
          <h2>Povestea brandului și artiștii</h2>
          <p>
            <i>
              Pasiune transmisă din generație în generație pentru a crea produse
              cu poveste.
            </i>
          </p>
          <p>
            Salut! Mă numesc Maria și am creat Firu’ Artei pentru a pune în
            valoare darul bunicii mele de a transforma orice grămadă de fire
            încâlcite într-o adevărată operă de artă. Suntem o afacere mică de
            familie, care și-a dorit să ducă mai departe darul străbunicii
            (Mama) de a crea produse handmade. Aici nu vorbim doar despre
            poșete, ghiozdane sau accesorii croșetate, vorbim despre povești
            cusute fir cu fir, nod cu nod, uneori chiar și cu un pic de nervi,
            dar mereu cu multă dragoste pe care ne dorim să o împărtășim.
          </p>
        </div>
        <div className="about-image">
          <img src="/poze-despre/despre_1.jpg" alt="Picture 1" />
        </div>
      </div>

      {/* Al doilea rând */}
      <div className="about-row-down">
        <div className="about-image">
          <img src="/poze-despre/despre_2.jpg" alt="Picture 2" />
        </div>
        <div className="about-text">
          <h2>Artizanatul</h2>
          <p>
            La Firu’ Artei, ne plac detaliile. Fiecare produs este lucrat
            manual, cu răbdare, cafea (multă cafea) și un playlist bine ales-
            pentru că firele se croșetează mai bine pe muzică bună. Indiferent
            dacă ești aici să găsești cadoul perfect sau să-ți faci un moft bine
            meritat, promitem să-ți oferim ceva unic, făcut cu suflet. Așa că,
            dă-ne voie să-ți aducem puțină magie croșetată în viață.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
